import { ApiArticle, ApiArticleCategory } from "@/services/articles/schemas"
import { localizeContent } from "../contents/localizers"
import { byLanguage } from "../languages/helpers"
import { localizeSeo } from "../seos/localizers"

/**
 * localizeArticle
 */
export const localizeArticle = ({
  seo,
  content,
  categoryId,
  authorId,
  publishedAt,
  publishedFrom,
  publishedTo,
  createdAt,
  updatedAt,
  ...parsed
}: ApiArticle) => ({
  ...D.selectKeys(parsed, ["id", "type", "state", "trackingId"]),
  seo: localizeSeo(seo),
  content: localizeContent(content),
  category: categoryId,
  author: authorId,
  publishedAt: T.parseISO(publishedAt),
  publishedFrom: publishedFrom ? T.parseISO(publishedFrom) : null,
  publishedTo: publishedTo ? T.parseISO(publishedTo) : null,
  createdAt: T.parseISO(createdAt),
  updatedAt: T.parseISO(updatedAt),
})
export type Article = ReturnType<typeof localizeArticle>

/**
 * localizeArticleCategory
 */
export const localizeArticleCategory = (parsed: ApiArticleCategory) => ({
  ...D.selectKeys(parsed, ["id", "order"]),
  translations: byLanguage(parsed.translations),
})
export type ArticleCategory = ReturnType<typeof localizeArticleCategory>
